import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { FileUpload } from '@app-libs/model';
import { formatFilename } from '../../../../utils/message-format.utils';

@Component({
  selector: 'app-file-attachment',
  standalone: true,
  imports: [CommonModule, MatIcon],
  templateUrl: './file-attachment.component.html',
  styleUrls: ['./file-attachment.component.scss']
})
export class FileAttachmentComponent {
  @Input() file: FileUpload | null | undefined = null;
  @Input() showDeleteButton = false;
  @Output() deleteFile = new EventEmitter<FileUpload>();

  getFormattedFilename(filename: string | undefined): string {
    if (!filename) return '';
    return formatFilename(filename);
  }

  onDeleteClick(): void {
    if (this.file) {
      this.deleteFile.emit(this.file);
    }
  }
}